import React from 'react';
import i18n from 'i18next';

import { createStyles, withStyles } from '@material-ui/core';

import { config } from '../../config';
import { tenantAgent } from '../../config/constants';

const styles = () =>
  createStyles({
    link: {
      color: '#3182ab',

      '&:hover': {
        color: '#235b76',
      },
    },
  });

const Notification: React.FC<any> = (props) => {
  const link = (
    <a
      className={props.classes.link}
      href={config.MARKETPLACE_URL}
      target="_blank"
      style={{ textTransform: 'uppercase' }}
      rel="noreferrer"
    >
      {i18n.t('subscription:market', { tenant: tenantAgent })}
    </a>
  );
  const message = i18n.t('subscription:expiration_warning', {
    days: props.daysToExpire,
    subscriptionName: props.productName,
  });
  const parts = message.split(':marketLink:');
  return (
    <span>
      {parts[0]}
      {link}
      {parts[1]}
    </span>
  );
};

const StyledNotification = withStyles(styles)(Notification);

export const SubscriptionNotification = (productName: string, daysToExpire: number) => (
  <StyledNotification productName={productName} daysToExpire={daysToExpire} />
);
